document.addEventListener('DOMContentLoaded', function() {
  const newsletterForms = document.querySelectorAll('.footer-newsletter-form');
  
  newsletterForms.forEach(function(form) {
    form.addEventListener('submit', function(event) {
      event.preventDefault();
      
      var button = form.querySelector('button[type="submit"]');
      var emailInput = form.querySelector('input[name="contact[email]"]');
      var messageBox = form.querySelector('.nl-message-box');
      var successMsg = form.getAttribute('data-success-message') || "Thanks. You're subscribed.";
      
      button.disabled = true;
      button.classList.add('is-loading');
      messageBox.innerHTML = '';
      
      var formData = new FormData(form);
      
      fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        if (data.errors) {
          var emailError = data.errors.email ? data.errors.email[0] : '';
          if (emailError && (emailError.indexOf('already been taken') > -1 || emailError.indexOf('already exists') > -1)) {
            messageBox.innerHTML = '<p class="nl-msg--error">This email is already subscribed.</p>';
          } else {
            messageBox.innerHTML = '';
          }
        } else {
          messageBox.innerHTML = '<p class="nl-msg--success">' + successMsg + '</p>';
          emailInput.value = '';
        }
      })
      .catch(function(error) {
        console.error('Newsletter submission error:', error);
        messageBox.innerHTML = '<p class="nl-msg--error">Something went wrong. Please try again.</p>';
      })
      .finally(function() {
        button.disabled = false;
        button.classList.remove('is-loading');
      });
    });
  });
});